import './type_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.PostSourceFilterView extends Monitoring.Views.SocialContents.Filters.TypeFilterView

  getAppliedValues: ->
    @searchQuery.get('post_source')

  addFilter: (value) ->
    @searchQuery.addPostSource(value)
